import {
    AfterViewInit,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { IStatusMessage, ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromDataServices from '../../data-services';
import { Process } from '../../shared';
import { SelectItem, Table } from '../../shared/efaact-primeng.module';
import { ContractClass } from '../store/contract-class.model';
import { IShowErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-class-presenter',
    templateUrl: './class-presenter.component.html',
    styleUrls: ['./class-presenter.component.scss'],
    standalone: false
})
export class ClassPresenterComponent
    implements OnInit, AfterViewInit, OnDestroy {
    SelectedErrorSubject = new ReplaySubject<IStatusMessage>(1);
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        this.SelectedErrorSubject.next(value);
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    @Output() public ShowError = new EventEmitter<IShowErrors>();

    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }

    private ContractClassSubject = new ReplaySubject<Array<ContractClass>>(1);
    private _contractclasses: Array<ContractClass>;
    @Input() set contractClasses(value: Array<ContractClass>) {
        if (value) {
            this._contractclasses = value;
            this.ContractClassSubject.next(value);
            this.classesSelectItem = value.map(x => ({
                value: x.ClassListID,
                label: x.ClassName
            }));
        }
    }
    get contractClasses(): Array<ContractClass> {
        return this._contractclasses;
    }

    private ContractsSubject = new ReplaySubject<
        Array<fromDataServices.Contract.Contract>
    >(1);
    private _contracts: Array<fromDataServices.Contract.Contract>;
    @Input() set contracts(value: Array<fromDataServices.Contract.Contract>) {
        if (value && value.length > 0) {
            this._contracts = value;
            this.ContractsSubject.next(value);
            this.contractsSelectItem = value.map(x => ({
                value: x.ContractListID,
                label: x.ContractDesc
            }));
        }
    }
    get contracts(): Array<fromDataServices.Contract.Contract> {
        return this._contracts;
    }

    @Input() public process: Process;

    active = true;

    @Output() LoadContractClasses = new ReplaySubject<any>(1);
    @Output() SaveContractClasses = new ReplaySubject<any>(1);

    @Output() Select = new ReplaySubject<ContractClass>(1);
    selected: ContractClass[];
    selectedContractListID: string;
    selectedContract = 'Contract';
    oldListID: string;
    contractsSelectItem: SelectItem[];
    classesSelectItem: SelectItem[];
    @ViewChild(Table, { static: true }) ContractTable: Table;
    @ViewChild(Table, { static: true }) ClassesTable: Table;

    constructor(private log: LoggingService) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {}

    ngOnDestroy(): void {
        this.active = false;
    }

    setupSubscriptions() {
        this.log.verbose({
            type: 'ClassPresenterComponent:setupSubscriptions'
        });
    }

    classesClicked(contractListID, contractDesc) {
        if (this.oldListID) {
            const oldRow = document.getElementById(`row-${this.oldListID}`);
            oldRow.classList.remove('highlight');
        }

        this.oldListID = contractListID;
        const row = document.getElementById(`row-${contractListID}`);
        row.classList.add('highlight');
        this.selectedContractListID = contractListID;
        this.selectedContract = contractDesc;
        this.LoadContractClasses.next(contractListID);
    }

    onRowSelect($event) {
        this.log.verbose({
            type: 'ClassPresenterComponent:onRowSelect',
            $event
        });
        this.Select.next($event.data);
        // this.selected = $event.data;
    }

    IsContractClassChecked($event, rowData) {
        // Update the local array to reflect the checkbox change
        const updatedClasses = this.contractClasses.map(x =>
            x.ClassListID === rowData.ClassListID
                ? { ...x, IsContractClass: $event.checked, ContractListID: this.selectedContractListID }
                : x
        );
        this._contractclasses = updatedClasses;

        this.SaveContractClasses.next([
            {
                ContractListID: this.selectedContractListID,
                ClassListID: rowData.ClassListID,
                IsContractClass: $event.checked
            }
        ]);
    }

    assignAllClicked() {
        const updatedClasses = this.contractClasses.map(x => ({
            ...x,
            IsContractClass: true,
            ContractListID: this.selectedContractListID
        }));
        this._contractclasses = updatedClasses;
        this.SaveContractClasses.next(updatedClasses);
    }

    unassignAllClicked() {
        const updatedClasses = this.contractClasses.map(x => ({
            ...x,
            IsContractClass: false,
            ContractListID: this.selectedContractListID
        }));
        this._contractclasses = updatedClasses;
        this.SaveContractClasses.next(updatedClasses);
    }

    //   filterContracts($event) {

    //     this.
    //   }
}
